/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Exercise_Sheet_Map_LabelInputs */

const en_us2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muscles worked: ${i?.names}`)
};

const pt_br2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Músculos trabalhados: ${i?.names}`)
};

const es_419_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Músculos trabajados: ${i?.names}`)
};

const pt_pt2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Músculos trabalhados: ${i?.names}`)
};

const fr_fr2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muscles travaillés : ${i?.names}`)
};

const de_de2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beanspruchte Muskeln: ${i?.names}`)
};

const it_it2_exercise_sheet_map_label = /** @type {(inputs: Exercise_Sheet_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muscoli coinvolti: ${i?.names}`)
};

/**
* | output |
* | --- |
* | "Muscles worked: {names}" |
*
* @param {Exercise_Sheet_Map_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_map_label = /** @type {((inputs: Exercise_Sheet_Map_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Map_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_map_label(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_map_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_map_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_map_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_map_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_map_label(inputs)
	return en_us2_exercise_sheet_map_label(inputs)
});
export { exercise_sheet_map_label as "exercise-sheet.map_label" }